import { createContext, useContext } from "react";

/** Exposes redesign-shell context to nested meeting controls without adding route props or import cycles. */
const RedesignMeetingsContext = createContext(false);

export const RedesignMeetingsProvider = RedesignMeetingsContext.Provider;
export const useIsRedesignMeetings = () => useContext(RedesignMeetingsContext);
